function subscribeBackInStock(email, shopifyVariantId) {
  const payload = {
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email
            }
          }
        },
        channels: ["EMAIL"]
      },
      relationships: {
        variant: {
          data: {
            type: "catalog-variant",
            id: `$shopify:::$default:::${shopifyVariantId}`
          }
        }
      }
    }
  };

  fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=X3UWGi", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "revision": "2024-06-15"
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (response.status === 202) {
        console.log("Subscribed successfully!");
      } else {
        response.json().then(err => console.error("Error:", err));
      }
    })
    .catch(error => console.error("Network error:", error));
}


document.addEventListener("click", function (e) {
    const icon = e.target.closest(".product-notify-block .product-notify-block__icon");

    if (icon) {
        document.querySelector(".product-notify-block__error_message.rte").style.display = "none";
        document.querySelector(".product-notify-block__success_message.rte").style.display = "none";

        const email     = document.querySelector("input.product-notify-block__input").value;
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
          document.querySelector(".product-notify-block__error_message.rte").style.display = "block";
          return ;
        }
        const shopifyVariantId = ShopifyAnalytics.meta.selectedVariantId;
        subscribeBackInStock(email, shopifyVariantId);
        document.querySelector(".product-notify-block__success_message.rte").style.display = "block";
        document.querySelector("input.product-notify-block__input").value = "";
    }
});